import React, { Suspense } from "react";
import DownloadingResources from "./DownloadingResources";


function DelayUnmount({
    mount,
    children,
    // delay = 500
}) {


    return (
        <React.Fragment>
            {mount ? (
                <Suspense fallback={<DownloadingResources />}>
                    {children}
                </Suspense>
            ) : null}
        </React.Fragment>
    );
}

export default DelayUnmount;
